module.exports = __FOREMAN_VENDOR__JQUERY__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__JQUERY__"
// module id = jquery
// module chunks = 32